import {lazy, Suspense} from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const LazyReportErrorMessage = lazy(() => import('./ReportErrorMessage'));

function fallbackComponent() {
  return (
    <LinearProgress classes={{root: 'ReportErrorMessage loading'}} variant="indeterminate" color="primary"/>
  );
}

const ReportErrorMessage = props => (
  <Suspense fallback={fallbackComponent()}>
    <LazyReportErrorMessage {...props} />
  </Suspense>
);

export default ReportErrorMessage;
